import { Anchor, type AnchorProps } from "@marketplace/ui";
import { createLink, type LinkComponent } from "@tanstack/react-router";
import { forwardRef } from "react";

interface MantineAnchorProps extends Omit<AnchorProps, "href"> {
  className?: string;
}

const MantineLinkComponent = forwardRef<HTMLAnchorElement, MantineAnchorProps>(
  (props, ref) => {
    return <Anchor ref={ref} {...props} />;
  }
);

const CreatedLinkComponent = createLink(MantineLinkComponent);

export const RouterLink: LinkComponent<typeof MantineLinkComponent> = (
  props
) => {
  return <CreatedLinkComponent preload="intent" {...props} />;
};
